import { createContext, useContext } from 'react'
import type { HouseholdRepository } from '@domain/ports/household-repository'

/**
 * O acesso da UI aos dados da casa, sempre pela porta — nunca pelo adapter.
 *
 * Em módulo próprio, sem componente junto, pelo mesmo motivo de
 * `auth-context.ts`: um arquivo que exporta componente **e** outra coisa quebra
 * o Fast Refresh, e o `react-refresh/only-export-components` reprova.
 *
 * Quem injeta a implementação é `src/main.tsx`; em teste, o `renderApp` de
 * `src/test/auth-fixtures.tsx` injeta uma dublê. É por isso que a tela de
 * Ajustes roda em teste sem mock de módulo do SDK do Firebase.
 */
export const HouseholdRepositoryContext = createContext<HouseholdRepository | null>(null)

export function useHouseholdRepository(): HouseholdRepository {
  const value = useContext(HouseholdRepositoryContext)
  if (value === null) {
    throw new Error(
      'useHouseholdRepository: falta um <HouseholdRepositoryContext.Provider> acima na árvore.',
    )
  }
  return value
}
